import { CdkPortalOutlet, ComponentPortal } from '@angular/cdk/portal';
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Inject, OnDestroy, OnInit, Output, signal } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { forkJoin, Observable } from 'rxjs';
import { SectionIndexItem } from '../../../../form-builder-viewer/models/section-index/section-index.model';
import { DynFormSection } from '../../../model/dyn-form/dyn-form-section.model';
import { DynFormBase } from '../../../model/dyn-form/dyn-form.model';
import { EFormHeaderModelValue, EFormSection, EFormSectionModelValueResponse, EFormView, EFormViewRegistry, EFormViewSection, SectionMetadata } from '../../../model/eform/eform-api.model';
import { ProcedureInstanceBase } from '../../../model/procedure-instance/procedure-instance.model';
import { EFormDynFormService } from '../../../services/eform/e-form-dyn-form.service';
import { EFormSectionMetadataService } from '../../../services/eform/e-form-section-metadata.service';
import { EFormValueService } from '../../../services/eform/e-form-value.service';
import { EFormViewFactoryService } from '../../../services/eform/e-form-view-factory.service';
import { ProcedureInstanceVisibilityService } from '../../../services/procedure-instance/procedure-instance-visibility.service';

@Component({
	selector: 'app-e-form-view-default',
	templateUrl: './e-form-view-default.component.html',
	styleUrls: ['./e-form-view-default.component.scss'],
	standalone: true,
	imports: [
		CommonModule,
		CdkPortalOutlet
	]
})
export class EFormViewDefaultComponent implements EFormView, OnInit, OnDestroy {

	currentForm = signal<DynFormBase | null>(null)
	formSectionMetadataState = signal<SectionMetadata[]>([])
	openedComponentSection = signal<(ComponentPortal<EFormViewSection> | null)[]>([])
	openedDynFormSection = signal<(DynFormSection | null)[]>([])
	openedEFormSection = signal<EFormSection[]>([])

	sectionIdAlreadyLoaded : number [] = []

	@Output()
	sectionEmitter: EventEmitter<SectionIndexItem[]> = new EventEmitter()


	constructor(@Inject("CONTAINER_DATA") public data: {
		registry: EFormViewRegistry,
		procedureInstance: ProcedureInstanceBase, 	},
		protected snackBar: MatSnackBar,
		protected procedureInstanceVisibilityService : ProcedureInstanceVisibilityService,
		protected dynFormService: EFormDynFormService,
		protected eFormViewFactoryService: EFormViewFactoryService,
		protected eFormSectionMetadataService: EFormSectionMetadataService,
		protected eFormValueService: EFormValueService) {

	}

	sections(): Observable<SectionIndexItem[]> {
		return this.sectionEmitter
	}

	isAllSectionsLoaded = (sectionId: number): void => {
		
		let isLoaded = this.sectionIdAlreadyLoaded.find(sectionIdLoaded => sectionId == sectionIdLoaded)
		if (isLoaded == undefined) {
			this.sectionIdAlreadyLoaded.push(sectionId)
		}

		if (this.currentForm() == null && this.formSectionMetadataState().length == 0) {
			return
		}

		let allSectionsNeeded = this.formSectionMetadataState().filter(section => section.shown == true)
		for (let needed of allSectionsNeeded) {
			if (!this.sectionIdAlreadyLoaded.includes(needed.sectionId)) {
				return
			}
		}

		this.data.registry.isAllSectionsLoaded();
	}


	ngOnInit(): void {

		this.sectionIdAlreadyLoaded = []
		this.data.registry.registerView(this)

		const getInfo = () => {
			forkJoin<[DynFormBase, { ok: boolean, entity: EFormHeaderModelValue, messageCode: string }]>(
				[this.dynFormService.findDynForm(this.data.procedureInstance.procedureFormId),
				this.eFormValueService.getEFormHeaderModelValue(this.data.procedureInstance.serviceInstanceId, this.data.procedureInstance.id)]).
			subscribe(rb => {
				let dynForm = rb[0]
				let headerValue = rb[1]
				if (headerValue.ok == false) {
					//TODO: DO something
					console.log("Header recover error")
					this.snackBar.open(`Error al carregar la capçalera: ${this.data.procedureInstance.serviceInstanceId} - ${this.data.procedureInstance.id}`)
					return
				}

				let calls: Observable<SectionMetadata>[] = [] //The default Section Metadata
				dynForm.sections.forEach(s => {
					calls.push(this.eFormSectionMetadataService.find(s))
				})

				forkJoin(calls).subscribe(m => {
					let visibleSectionItems: SectionIndexItem[] = []
					this.currentForm.set(dynForm)
					this.formSectionMetadataState.set(m)
					if (headerValue.entity == null) {
						//If there is no data !!! may be is an error!!! 

					} else {
						//Merge the metadata with values EFormHeaderModelValue stored into the S3. (Update the default values with the current form values)
						this.mergeFormSectionMetadataState(headerValue);
					}

					//Open all the sections...
					for (let index = 0; index < this.currentForm()!.sections.length; index++) {
						const element = this.currentForm()!.sections[index];
						this.createComponentSection(element, index)
						if (this.formSectionMetadataState()[index].shown == true) {
							visibleSectionItems.push({ id: 'sec-view-' + this.currentForm()!.sections[index].id, name: this.currentForm()!.sections[index].name })
						}
					}

					//Emit the section information
					this.sectionEmitter.emit(visibleSectionItems)

				})

				this.loadAllSectionValues(dynForm);

			})
		}

		if (this.data.registry.secretInitialize()) {
			getInfo()
			return
		}

		this.procedureInstanceVisibilityService.check([this.data.procedureInstance]).subscribe(r => {
			getInfo()
			return
		})
	}

	createComponentSection(section: DynFormSection, index: number) {
		this.openedComponentSection().push(null)
		this.openedDynFormSection().push(null)
		this.eFormViewFactoryService.newEFormViewSection(section, this.data.procedureInstance, this.isAllSectionsLoaded).subscribe(s => {
			this.openedComponentSection()[index] = s
			this.openedDynFormSection()[index] = section
		})

	}
	private mergeFormSectionMetadataState(headerValue: { ok: boolean; entity: EFormHeaderModelValue; messageCode: string; }) {
		headerValue.entity.sections.forEach(sec => {

			this.formSectionMetadataState.update((current) => {
				return current.map(item => {
					if (item.sectionId == sec.sectionId) {
						return { ...item, shown: sec.shown, validForm: sec.validForm }
					}
					return item
				})
			})

		});
	}

	/**
	 * 
	 * @param dynForm Preload all the values to cache them
	 */
	private loadAllSectionValues(dynForm: DynFormBase) {
		let valuesCalls: Observable<EFormSectionModelValueResponse>[] = [];
		dynForm.sections.forEach(s => {
			valuesCalls.push(this.eFormValueService.getEFormSectionModelValue(this.data.procedureInstance.serviceInstanceId, this.data.procedureInstance.id, s.id));
		});


		forkJoin(valuesCalls).subscribe(m => {

		});
	}

	ngOnDestroy(): void {
		this.data.registry.unRegisterView(this)
	}

}
